module.exports = __webpack_public_path__ + "static/media/chessOsm.9fcfbfcc.jpg";